import {
    useMemo,
    type FC
} from "react";
import {
    View
} from "react-native";
import type IFieldGroupProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useFieldGroupContext,
    FieldGroupContext
} from "../../context";
import type {
    FieldGroupContextType
} from "../../type";
import {
    getIsFieldOptionList
} from "../../util";

const FieldGroup: FC<IFieldGroupProps> = ({
    customTheme: customThemeProp,
    orientation,
    children,
    style,
    ...props
}) => {
    const parentContext = useFieldGroupContext();

    const customTheme = customThemeProp ?? parentContext?.customTheme;

    const {
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        container: containerDynamicStyle
    } = useStyles({
        isOptionList: getIsFieldOptionList({
            children
        }),
        spaces
    });

    const context = useMemo<FieldGroupContextType>(() => ({
        orientation: orientation ?? parentContext?.orientation,
        customTheme
    }), [
        parentContext?.orientation,
        orientation,
        customTheme
    ]);

    return <FieldGroupContext.Provider
        value={context}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container,
                containerDynamicStyle
            ]}
        >
            {children}
        </View>
    </FieldGroupContext.Provider>;
};
export default FieldGroup;
